import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { css } from 'emotion';
import { Select, Modal } from '@douyinfe/semi-ui';
import { IconChevronDown } from '@douyinfe/semi-icons';
import { Consumer } from '@/store';
import { getLocalText } from '@/utilities/language';
import { languageOpts } from '@/constant';
var LanguagePC = function LanguagePC(props) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    visible = _useState2[0],
    setVisible = _useState2[1];
  var _useState3 = useState(window.language),
    _useState4 = _slicedToArray(_useState3, 2),
    language = _useState4[0],
    setLanguage = _useState4[1];
  return React.createElement(Consumer, null, function (store) {
    var _store$state = store.state,
      quest = _store$state.quest,
      questions = _store$state.questions;
    var _ref = quest || {},
      _ref$multiLngList = _ref.multiLngList,
      multiLngList = _ref$multiLngList === void 0 ? [] : _ref$multiLngList,
      localLanguage = _ref.localLanguage,
      canSelectLanguage = _ref.canSelectLanguage,
      answerAfterSelectLanguage = _ref.answerAfterSelectLanguage,
      theme = _ref.theme;
    if (!window.selectdLang) {
      setVisible(answerAfterSelectLanguage);
      setTimeout(function () {
        window.selectdLang = true;
      }, 500);
    }
    var languageColumns = multiLngList.map(function (item) {
      var _languageOpts$find;
      return {
        label: (_languageOpts$find = languageOpts.find(function (l) {
          return l.value === item.language;
        })) === null || _languageOpts$find === void 0 ? void 0 : _languageOpts$find.label,
        value: item.language
      };
    });
    var triggerRender = function triggerRender(_ref2) {
      var _value$;
      var value = _ref2.value;
      return React.createElement("div", {
        className: "selectRender"
      }, React.createElement("div", {
        className: "lang-label"
      }, getLocalText('language')), React.createElement("div", {
        className: "selectVal"
      }, value === null || value === void 0 ? void 0 : (_value$ = value[0]) === null || _value$ === void 0 ? void 0 : _value$.label, React.createElement(IconChevronDown, {
        style: {
          marginLeft: 4,
          flexShrink: 0
        }
      })));
    };
    var triggerRender2 = function triggerRender2(_ref3) {
      var _value$2;
      var value = _ref3.value;
      return React.createElement("div", {
        className: "selectRender2"
      }, React.createElement("div", {
        className: "selectVal"
      }, React.createElement("div", {
        style: {
          width: 282
        }
      }, value === null || value === void 0 ? void 0 : (_value$2 = value[0]) === null || _value$2 === void 0 ? void 0 : _value$2.label), React.createElement(IconChevronDown, {
        style: {
          marginLeft: 4,
          flexShrink: 0
        }
      })));
    };
    return React.createElement("div", {
      className: languageCls(theme)
    }, canSelectLanguage && React.createElement(Select, {
      value: window.language,
      triggerRender: triggerRender,
      optionList: languageColumns,
      onChange: function onChange(value) {
        window.language = value;
        window.selectdLang = true;
        window.showMultiLang = value !== localLanguage;
        store.action.update(questions.map(function (q) {
          return q.id;
        }));
      }
    }), React.createElement(Modal, {
      title: getLocalText('language'),
      visible: visible,
      okText: getLocalText('Content.Form.Ok'),
      cancelText: getLocalText('Content.Form.Cancel'),
      onOk: function onOk() {
        window.language = language;
        window.selectdLang = true;
        window.showMultiLang = language !== localLanguage;
        store.action.update(questions.map(function (q) {
          return q.id;
        }));
        setVisible(false);
      },
      onCancel: function onCancel() {
        return setVisible(false);
      }
    }, React.createElement("div", {
      className: languageModalCls
    }, React.createElement("div", {
      style: {
        marginRight: 12
      }
    }, getLocalText('language')), React.createElement(Select, {
      value: language,
      triggerRender: triggerRender2,
      optionList: languageColumns,
      onChange: function onChange(value) {
        setLanguage(value);
      }
    }))));
  });
};
export default LanguagePC;
var _ref4 = "display:flex;margin-bottom:12px;.selectRender{background-color:";
var _ref5 = ";height:32px;display:flex;align-items:center;padding:5px 12px;border-radius:3px;color:";
var _ref6 = ";.lang-label{flex-shrink:0;font-size:12px;}.selectVal{margin-left:12px;display:flex;align-items:center;font-weight:500;white-space:nowrap;text-overflow:ellipsis;flex-grow:1;overflow:hidden;color:rgb(22,93,255);font-size:12px;cursor:pointer;.semi-icon{font-size:12px;}}}";
var languageCls = function languageCls(theme) {
  return /*#__PURE__*/css(_ref4, theme ? 'var(--question-bg)' : '#fff', _ref5, theme ? 'var(--text-color)' : '#4e5969', _ref6);
};
var languageModalCls = /*#__PURE__*/css("display:flex;align-items:center;padding:0 12px;border:1px solid #dde2e9;border-radius:4px;font-size:12px;color:#42464e;.selectRender2{height:32px;display:flex;align-items:center;border-left:1px solid #dde2e9;background-color:#fff;.selectVal{padding-left:12px;display:flex;align-items:center;color:#0c0d0e;font-size:12px;cursor:pointer;.semi-icon{font-size:12px;}}}");